import { GroupedDepartmentOption, Option } from '../../../../helpers'

export default function getDepartmentOptionByGroupId(groupedDepartments: GroupedDepartmentOption[], id: string): Option[] {
    const group = groupedDepartments.find(groupedDepartment => groupedDepartment.id === id)

    return group ? group.options : []
}
